export default "__VITE_ASSET__BEA4KDVb__"